import cls from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import { SkeletonProps } from './types';
import { buildResponsiveStyles } from './utils';

const Skeleton = ({
    loading = true,
    width,
    height,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    className,
    style,
    children,
    margin,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    marginX,
    marginY,
    ...props
}: SkeletonProps) => {
    // 构建样式对象
    const skeletonStyle: React.CSSProperties = {
        ...buildResponsiveStyles({
            width,
            height,
            minWidth,
            maxWidth,
            minHeight,
            maxHeight,
            margin,
            marginTop,
            marginRight,
            marginBottom,
            marginLeft,
            marginX,
            marginY,
        }),
        ...style,
    };

    // 如果有子元素
    if (!loading && children) {
        return (
            children
        );
    }

    // 如果没有子元素，只显示骨架屏
    if (loading) {
        return (
            <span
                className={cls(styles.skeleton, className)}
                style={skeletonStyle}
                {...props}
            />
        );
    }

    // loading 为 false 且没有子元素时，返回空内容
    return null;
};

export default Skeleton;
export type { SkeletonProps };
